<div class="min-h-screen bg-gradient-to-br from-yellow-800 to-yellow-950 flex items-center justify-center p-4">
    <div class="bg-white rounded-lg shadow-2xl max-w-md w-full p-6 overflow-hidden relative">
      <!-- Animated lock icon -->
      <div class="flex justify-center mb-6">
        <div class="relative">
          <div class="w-24 h-24 rounded-full bg-yellow-100 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <!-- Animated pulse ring -->
          <div class="absolute inset-0 rounded-full bg-yellow-400 opacity-25 animate-ping"></div>
        </div>
      </div>
      
      <!-- Title with animated warning -->
      <div class="mb-6 text-center">
        <h1 class="text-3xl font-bold text-yellow-600 mb-1 flex items-center justify-center">
          <span class="mr-2">Access Denied</span>
        </h1>
        <p class="text-gray-600">You don't have permission to access this page</p>
      </div>
            
      <!-- Action buttons -->
      <div class="flex flex-col sm:flex-row gap-3">
        <button [routerLink]="['/admin/duty-roster']" class="bg-yellow-600 text-white py-2 px-4 rounded-lg hover:bg-yellow-700 transition duration-200 flex-1 flex items-center justify-center cursor-pointer">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          Duty Roster
        </button>
      </div>
      
      <!-- Decorative elements -->
      <div class="absolute -top-10 -right-10 w-24 h-24 bg-yellow-400 rounded-full opacity-20"></div>
      <div class="absolute -bottom-10 -left-10 w-24 h-24 bg-yellow-400 rounded-full opacity-20"></div>
    </div>
  </div>